import {useAppSelector} from "../../../../../store/store";
import {useEffect, useState} from "react";
import {Role} from "../../../../../config/acl/roles/Role";
import {groupNotApproved} from "../../../../../config/acl/roles/groups";
import {UserStatus} from "../../../../../utils/constans/statuses/userStatuses";

export enum CompanyWarningStatusEnum {
  WARNING_LOAD_DOCUMENTS,
  WARNING_ON_MODERATION,
  WARNING_REJECTED,
  OK,
}

export const isCompanyOnLoadDocuments = (status: CompanyWarningStatusEnum) => status === CompanyWarningStatusEnum.WARNING_LOAD_DOCUMENTS;
export const isCompanyOnModeration = (status: CompanyWarningStatusEnum) => status === CompanyWarningStatusEnum.WARNING_ON_MODERATION;
export const isCompanyRejected = (status: CompanyWarningStatusEnum) => status === CompanyWarningStatusEnum.WARNING_REJECTED;

export const useCompanyWarningStatus = () => {
  const {role, userStatus} = useAppSelector(state => state.user.oneItemObject.item);
  const company = useAppSelector(state => state.company.oneItemObject.item);
  const [companyWarningStatus, setCompanyWarningStatus] = useState<CompanyWarningStatusEnum>(CompanyWarningStatusEnum.OK);
  const [companyWarningStatusColor, setCompanyWarningStatusColor] = useState<string>("#31CA91");

  const hasEmptyDocuments = () => (role === Role.freighterAdminNotApproved
    && (company.registrationCertificate === undefined || company.operatorCard === undefined))
  || (role === Role.chartererAdminNotApproved && (company.registrationCertificate === undefined));

  useEffect(() => {
    setNewStatus()
  }, [role, userStatus, company.registrationCertificate, company.operatorCard])

  const setNewStatus = () => {
    if (userStatus === UserStatus.REJECTED) {
      setCompanyWarningStatus(CompanyWarningStatusEnum.WARNING_REJECTED);
      setCompanyWarningStatusColor("#C90000");
      return;
    }

    if (groupNotApproved.includes(role)) {
      if (hasEmptyDocuments()) {
        setCompanyWarningStatus(CompanyWarningStatusEnum.WARNING_LOAD_DOCUMENTS);
        setCompanyWarningStatusColor("#C90000")
        return;
      }

      setCompanyWarningStatus(CompanyWarningStatusEnum.WARNING_ON_MODERATION)
      setCompanyWarningStatusColor("#F4B237")
      return;
    }

    setCompanyWarningStatus(CompanyWarningStatusEnum.OK);
    setCompanyWarningStatusColor("#31CA91")
  }

  return {companyWarningStatus, companyWarningStatusColor};
}